import { Button, IconButton, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useState } from 'react';
import { InputLabel } from '@mui/material';
import BackupIcon from '@mui/icons-material/Backup';
import CancelIcon from '@mui/icons-material/Cancel';
import { downloadFileFullPath, removeNthEl, saveFile } from '../../../lib/helperFuncs';
import { useTranslation } from 'react-i18next';
import Theme from '../../../Themes/main.theme';

function SimpleFileUpload(props: any) {
  const { name, multiple = false, accepts, onFileSelect, value = '', ...rest } = props;
  const [files, setFiles] = useState<File[]>([value]);

  const { t } = useTranslation();

  return (<>
    <Button disableRipple component='label'
      sx={{ '&:hover': { cursor: 'inherit', } }}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minWidth: '380px',
        minHeight: '150px',
        border: '2px dashed #cbd5e0',
        backgroundColor: Theme?.labelColor?.background
      }}>
      <input
        name={name}
        accept={accepts?.toString()}
        multiple={multiple}
        {...rest}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const _files = e.target.files || [];
          let newState: File[];
          onFileSelect && onFileSelect(e.target.files);
          if (!multiple) {
            newState = [..._files];
          } else {
            newState = [...files, ..._files];
          }
          setFiles(newState);
        }}
        type='file'
        hidden
      />
      <Box display='flex' justifyContent='space-evenly'
        columnGap={20}>
        <Box display='flex' flexDirection='column'
          justifyContent='center' alignItems='center'>
          <BackupIcon color='primary' sx={{ fontSize: '4rem' }} />
          <Typography mt={2} color='InfoText'
            style={{ whiteSpace: 'pre-line', display: 'block', textTransform: 'none' }}>
            {t('Κάντε κλίκ ή σύρετε για να ανεβάσετε τα αρχεία σας')}
          </Typography>
          <Typography mt={1} color='InfoText'
            style={{ whiteSpace: 'pre-line', display: 'block', textTransform: 'none' }}>
            {t('Τύπος αρχείων που υποστηρίζονται')}
            {accepts?.map((x: any, index: number) => {
              if (!x) return;

              if (index === 0) {
                return ` ${x}`;
              } else {
                return `, ${x}`;
              }
            })}
          </Typography>
        </Box>
        <Box
          display='flex'
          flexDirection='column'
          gap={2}>
          {files?.map((x: any, index: number) => {
            if (!x) return;
            return <>
              <Box key={`${x}`} display='flex'
                gap={5}
                alignItems='center'
                justifyContent='center'>
                <Button variant='text'
                  onClick={() => typeof x == 'object'
                    ? saveFile(x)
                    : downloadFileFullPath(x)}
                  sx={{ '&:hover': { backgroundColor: 'transparent' } }}
                >{typeof x == 'object'
                    ? x?.name
                    : x?.split('/')?.at(-1)
                  }
                </Button>
                <IconButton onClick={(e: any) => {
                  e.stopPropagation();
                  e.preventDefault();
                  const newState = removeNthEl(files, index);
                  setFiles(newState);
                }}>
                  <CancelIcon />
                </IconButton>
              </Box>
            </>;
          })}
        </Box>
      </Box>
    </Button>
  </>);
}


// wrapped in textFiled
function _FormFileUpload(props: any) {
  const { label, required } = props;
  return (
    <>
      <InputLabel
        required={required}
        sx={{
          textAlign: 'left',
          textStyle: 'none',
          color: 'black'
        }}
      >
        {label}
      </InputLabel>
      <Box my={2}>
        <SimpleFileUpload {...props} />
      </Box>
    </>
  );
}

function FormFileUploadSimple(props: any) {
  return (
    <>
      <Box width='100%'>
        <_FormFileUpload {...props} />
      </Box>
    </>
  );
}

export default FormFileUploadSimple;